import React from "react"
import ScrollUpButton from "react-scroll-up-button";
export default () => <ScrollUpButton />

